import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown24 } from '@onefootprint/icons';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import Flag from '../../../../../flag';
type CountryPickerProps = {
  code: Iso3166TwoDigitCountryCode;
  disabled: boolean;
  onClick?: () => void;
  prefix: string;
};
const CountryPicker = t0 => {
  const $ = _c(10);
  const {
    prefix,
    disabled,
    code,
    onClick
  } = t0;
  let t1;
  if ($[0] !== code) {
    t1 = <div className="ml-3"><Flag code={code} /></div>;
    $[0] = code;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="ml-1"><IcoChevronDown24 /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== prefix) {
    t3 = <div className="ml-2">{prefix}</div>;
    $[3] = prefix;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== disabled || $[6] !== onClick || $[7] !== t1 || $[8] !== t3) {
    t4 = <button onClick={onClick} type="button" disabled={disabled} className="text-body-2 flex items-center justify-center h-full px-1.5 bg-none border-none text-[inherit] select-none enabled:cursor-pointer [&>div]:flex">{t1}{t2}{t3}</button>;
    $[5] = disabled;
    $[6] = onClick;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default CountryPicker;